const Volumes = {
	
	name: 'Volumes',
	model: {

		idProperty: 'volumes__id',
		displayProperty: 'volumes__name',

		sorters: [
			{
				name: 'volumes__sort_order',
				direction: 'ASC',
			}
		],
		
		properties: [
 			{ name: 'volumes__id',	mapping: 'volume.id',	type: 'int', },
			{ name: 'volumes__name',	mapping: 'volume.name', },
			{ name: 'volumes__sort_order',	mapping: 'volume.sort_order',	type: 'int', },
		],

		associations: {

			hasMany: [
				'Divisions',
				'Questions'
			],

		},

	},

	entity: {
		methods: {

			getDivisions: function() {
				const Divisions = this.getAssociatedRepository('Divisions');
				return Divisions.getBy((entity) => {
					return entity.divisions__volume_id === this.volumes__id;
				});
			},

			getQuestions: function() {
				const Questions = this.getAssociatedRepository('Questions');
				return Questions.getBy((entity) => {
					return entity.questions__volume_id === this.volumes__id;
				});
			},

		},
	},

	repository: {
		type: 'lfr',
		local: {
			type: 'async',
			isPaginated: false,
			autoSave: true,
		},
		remote: {
			type: 'onebuild',
			isPaginated: false,
			autoSave: false,
		},
	},

};

export default Volumes;
